module.exports = __webpack_public_path__ + "img/UOB.d72a7c0c.svg";